module.exports = __webpack_public_path__ + "img/EU India.e9ee486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/EU India.png
// module id = 1131
// module chunks = 1